import { render, staticRenderFns } from "./Moviles.vue?vue&type=template&id=24d3478a&scoped=true&"
import script from "./Moviles.vue?vue&type=script&lang=ts&"
export * from "./Moviles.vue?vue&type=script&lang=ts&"
import style0 from "./Moviles.vue?vue&type=style&index=0&id=24d3478a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3478a",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QIcon,QImg});qInstall(component, 'directives', {Ripple});
